// Color mappings for various status strings
// Using object lookup instead of switch for better performance and no duplicate key issues

const COLOR_MAP: Record<string, string> = {
  // Deal Types
  Marketing: 'rgb(88, 188, 128)',
  MSA: 'rgb(88, 188, 128)',
  RMSA: 'rgb(88, 188, 128)',
  'MSA - Housing': 'rgb(88, 188, 128)',
  'RMSA - Housing': 'rgb(88, 188, 128)',
  IO: 'rgb(88, 188, 128)',
  'Housing Property': 'rgb(88, 188, 128)',
  Creative: 'rgb(165, 147, 255)',
  CSA: 'rgb(165, 147, 255)',
  RCSA: 'rgb(165, 147, 255)',

  // Document States
  draft: 'rgb(167, 172, 182)',
  Draft: 'rgb(167, 172, 182)',
  saved: 'rgb(35, 146, 173)',
  Saved: 'rgb(35, 146, 173)',
  sent: 'rgb(108, 218, 135)',
  Sent: 'rgb(93, 79, 251)',
  created: 'rgb(114, 229, 218)',
  Created: 'rgb(114, 229, 218)',

  // Hosting
  Hosting: 'rgb(121, 175, 253)',
  'Hosting 30': 'rgb(89, 133, 196)',
  'Hosting 60': 'rgb(46, 88, 146)',

  // Updates
  'Update Display Ads': 'rgb(51, 158, 205)',
  'Update Social Ads': 'rgb(181, 125, 227)',
  'Conversion Tracking': 'rgb(53, 153, 112)',
  'Search Updates': 'rgb(121, 175, 253)',
  'Social Updates': 'rgb(213, 197, 103)',
  'Display Updates': 'rgb(92, 92, 92)',
  'Other Channel Updates': 'rgb(201, 92, 118)',

  // Tiers
  Standard: 'rgb(165, 147, 255)',
  ECommerce: 'rgb(233, 148, 30)',
  Premium: 'rgb(246, 90, 252)',

  // Search/Social
  Search: 'rgb(213, 197, 103)',

  // Reviews
  'Search Review (Issue)': 'rgb(255, 68, 161)',
  'Social Review (Issue)': 'rgb(255, 123, 208)',
  'Display Review (Issue)': 'rgb(147, 111, 218)',
  'Other Review (Issue) ': 'rgb(255, 131, 88)',
  'Review / Audit': 'rgb(255, 131, 88)',
  reviewAudit: 'rgb(255, 131, 88)',
  Revise: 'rgb(255, 131, 88)',
  revise: 'rgb(255, 131, 88)',

  // Statuses
  'Not Started': 'rgb(153, 165, 165)',
  Enable: 'rgba(3, 201, 169, 1)',
  Pause: 'rgb(255, 145, 145)',
  Active: 'rgb(80, 200, 120)',
  'Active (system)': 'rgb(40, 249, 144)',
  Approved: 'rgb(6, 255, 167, 0.6)',
  Resolved: 'rgb(249, 167, 49)',
  '30 Day Notice': 'rgb(235, 77, 77)',
  Rejected: 'rgba(220, 20, 60, 0.9)',
  Expired: 'rgba(220, 20, 60, 0.9)',
  Ended: 'rgba(220, 20, 60, 0.9)',
  'Ended (system)': 'rgb(241, 9, 207)',
  'Expired (system)': 'rgb(241, 9, 207)',

  // Onboarding
  Onboarding: 'rgb(110, 193, 232)',
  'Awaiting Dependencies': 'rgb(59, 152, 245)',
  'Dependencies Received': 'rgb(245, 124, 79)',
  'Handoff Call': 'rgba(106, 65, 192, 1)',
  'Creative Intake': 'rgb(181, 125, 227)',
  Launched: 'rgb(52, 211, 145)',
  'Onboarding Completed': 'rgb(52, 211, 145)',

  // Contract States
  Cancelled: 'text.primary',
  Viewed: 'rgb(213, 102, 201)',
  'Contract Approved': 'rgb(255, 144, 69)',
  'Contract Created': 'rgb(11, 127, 171)',
  'Contract Sent': 'rgb(217, 169, 102)',
  'Strategy Approved': 'rgb(6, 255, 167)',
  'Sent For Approval': 'rgb(163, 96, 205)',
  'Approval Requested': 'rgba(255, 148, 112, 1)',
  'Needs Approval': 'rgb(251, 193, 30)',
  'Pending Approval': 'rgba(241, 130, 141, 1)',
  'Completed Internally': 'rgba(22, 160, 133, 1)',
  Completed: 'rgb(80, 200, 120)',
  Proposal: 'rgb(174, 92, 174)',
  Invoiced: 'rgb(80, 200, 120)',
  'Not Invoiced': 'rgb(249, 167, 49)',
  'Active - 30 Day Notice': 'rgb(255, 123, 208)',
  Optimization: 'rgb(65, 190, 169)',

  // Deals
  Deals: '#fbc11e',
  deals: '#fbc11e',
  'Month To Month': 'rgb(22, 138, 239)',
  Monthly: 'rgb(22, 138, 239)',
  monthly: 'rgb(22, 138, 239)',
  'N/A': 'rgb(90, 91, 93)',
  Requested: 'rgb(253, 188, 100)',
  Done: 'rgb(51, 211, 145)',
  Digital: 'rgb(51, 211, 145)',
  digital: 'rgb(51, 211, 145)',
  'Deal Won': 'rgb(51, 211, 145)',
  Contracted: 'rgb(51, 211, 145)',
  Yes: 'rgb(51, 211, 145)',
  'In Progress': 'rgb(253, 188, 100)',
  No: 'rgb(253, 188, 100)',
  Pending: 'rgb(187, 124, 239)',
  Parent: 'rgba(67, 85, 241, 1)',
  Stuck: 'rgb(232, 105, 125)',

  // Prospects
  Prospect: 'rgb(93, 79, 251)',
  Cold: 'rgb(168, 202, 255)',
  Observation: 'rgb(168, 202, 255)',
  observation: 'rgb(168, 202, 255)',

  // Leasing
  leasingPercentage: 'rgba(230, 181, 21, 1)',
  'Leasing Percentage': 'rgba(230, 181, 21, 1)',
  'Needs Review': 'rgb(33, 201, 223)',
  review: 'rgb(33, 201, 223)',
  'In-Progress': 'rgb(110, 156, 222)',

  // SEO/Active statuses
  'Active (SEO)': 'rgb(152, 98, 161)',
  'Active (Creative)': 'rgb(147, 111, 218)',
  'Active (Website)': 'rgb(88, 66, 133)',
  Website: 'rgb(129, 82, 223)',
  website: 'rgb(129, 82, 223)',
  'Website Structure': 'rgb(129, 82, 223)',
  'Website Design Overview': 'rgb(129, 82, 223)',
  'Active (Past Due)': 'rgb(255, 177, 88)',
  Webhook: 'rgb(255, 177, 88)',
  'Webhook update': 'rgb(255, 177, 88)',
  'Active (LTP)': 'rgb(51, 158, 205)',
  '30 day notice': 'rgb(235, 77, 77)',
  'Inactive / Paused': 'rgb(255, 145, 145)',
  Paused: 'rgb(255, 145, 145)',
  'Select Status': 'rgb(121, 126, 147)',
  'Waiting On Google': 'rgb(161, 227, 246)',

  // Task Statuses
  'DMS Attention': 'rgb(255, 131, 88)',
  'DMS Mo. Task': 'rgb(255, 131, 88)',
  'Awaiting Assignment': 'rgb(238, 111, 141)',
  'AM Attention': 'rgb(51, 158, 205)',
  'Need Client Feedback': 'rgb(133, 214, 255)',
  'AM Follow Up': 'rgb(43, 118, 229)',
  'Marketing Form': 'rgb(65, 190, 169)',
  Insight: 'rgb(65, 190, 169)',
  insight: 'rgb(65, 190, 169)',
  'Ready To Launch': 'rgb(121, 175, 253)',
  'Postdated (AM)': 'rgb(181, 125, 227)',
  'AM Mo. Task': 'rgb(181, 125, 227)',
  'Postdated (DMS)': 'rgb(147, 111, 218)',
  'On Hold': 'rgb(201, 92, 118)',
  'On Hold (Past Due)': 'rgb(201, 92, 118)',
  'Waiting on Creative': 'rgb(92, 92, 92)',
  'DMS SLA Change': 'rgb(119, 122, 229)',
  'AM SLA Change': 'rgb(53, 153, 112)',
  'Ready to QA': 'rgb(113, 214, 209)',
  'SEO Attention': 'rgb(232, 105, 125)',
  'PM Attention': 'rgb(78, 115, 167)',
  'Needs MI Attention': 'rgb(157, 153, 185)',
  'Waiting On Ad Approvals': 'rgb(255, 68, 161)',
  'Ad Approvals': 'rgb(255, 68, 161)',
  Churn: 'rgb(255, 123, 208)',
  Predecessor: 'rgb(255, 123, 208)',
  Ancestor: 'rgb(255, 123, 208)',

  // QA statuses
  'Ready to QA - Google Search': 'rgb(251, 180, 244)',
  'Ready to QA - FB/IG': 'rgb(255, 189, 189)',
  External: 'rgb(255, 189, 189)',
  'Ready to QA - GDN': 'rgb(217, 116, 176)',
  'Ready to QA - Simplifi': 'rgb(189, 168, 249)',
  'Ready to QA - TikTok': 'rgb(255, 145, 145)',
  'Ready to QA - Other': 'rgb(169, 190, 232)',

  // NCO
  'New Client Onboard': 'rgb(52, 211, 145)',
  Successor: 'rgb(52, 211, 145)',
  Descendant: 'rgb(52, 211, 145)',

  // Campaign
  'Campaign Checklists': 'rgb(133, 214, 255)',
  campaignChecklists: 'rgb(133, 214, 255)',
  'Campaign QA': 'rgb(133, 214, 255)',
  'Copy Update': 'rgb(253, 188, 100)',
  'Campaign Updates': 'rgb(255, 213, 51)',
  'Campaign Review': 'rgb(51, 211, 145)',
  'Budget Rec': 'rgb(232, 105, 125)',
  'Budget Updates': 'rgb(51, 158, 205)',
  Budget: 'rgb(51, 158, 205)',
  budget: 'rgb(51, 158, 205)',
  Bypass: 'rgba(108, 122, 137, 1)',
  'Launch New Creatives': 'rgb(181, 125, 227)',
  'GTM/GA Setup': 'rgb(53, 153, 112)',
  'Campaign Setup': 'rgb(121, 175, 253)',
  'AM Task  Update': 'rgb(213, 197, 103)',
  'Offboard Client': 'rgb(92, 92, 92)',

  // SEO
  'SEO Change': 'rgb(201, 92, 118)',
  'SEO Update': 'rgb(255, 68, 161)',
  SEO: 'rgb(238, 111, 141)',
  Seo: 'rgb(238, 111, 141)',
  seo: 'rgb(238, 111, 141)',
  'SEO Mo. Task': 'rgb(238, 111, 141)',
  Discovery: 'rgb(255, 123, 208)',
  'Strategy Request': 'rgb(147, 111, 218)',
  'New Agreement': 'rgb(255, 131, 88)',

  // Actions
  Approve: 'rgb(6, 255, 167, 0.6)',
  approve: 'rgb(6, 255, 167, 0.6)',
  Resolve: 'rgb(249, 167, 49)',
  resolve: 'rgb(249, 167, 49)',
  Reject: 'rgba(220, 20, 60, 0.9)',
  reject: 'rgba(220, 20, 60, 0.9)',
  Request: 'rgb(233, 136, 103)',
  request: 'rgb(233, 136, 103)',
  Generate: 'rgb(233, 136, 103)',
  Routing: 'rgb(233, 136, 103)',
  Creation: 'rgb(25, 117, 255)',
  creation: 'rgb(25, 117, 255)',
  Create: 'rgb(25, 117, 255)',
  'Create / Setup': 'rgb(25, 117, 255)',
  createSetup: 'rgb(25, 117, 255)',

  // Tiers
  'Tier 1': 'rgb(51, 158, 205)',
  'Tier 2': 'rgb(121, 175, 253)',
  'Tier 3': 'rgb(255, 131, 88)',
  'Tier 4': 'rgb(181, 125, 227)',
  Save: 'rgb(114, 229, 218)',

  // Task Types
  'New Client Onboards': 'rgb(40, 194, 127)',
  'Creative Tasks': 'rgb(167, 103, 253)',
  Update: 'rgb(114, 229, 218)',
  'Social Ads': 'rgb(51, 211, 145)',
  socialAd: 'rgb(51, 211, 145)',
  socialAds: 'rgb(51, 211, 145)',
  'Display Ads': 'rgb(253, 188, 100)',
  displayAds: 'rgb(253, 188, 100)',
  'Social & Display Ads': 'rgb(133, 214, 255)',
  'Logo Design': 'rgb(51, 158, 205)',
  logoDesign: 'rgb(51, 158, 205)',
  'logo design': 'rgb(51, 158, 205)',
  Design: 'rgb(51, 158, 205)',
  'Design Materials': 'rgb(51, 158, 205)',
  'design materials': 'rgb(51, 158, 205)',
  designMaterials: 'rgb(51, 158, 205)',
  'Print Design': 'rgb(51, 158, 205)',
  printDesign: 'rgb(51, 158, 205)',
  'Full Brand Build': 'rgb(181, 125, 227)',
  fullBrandBuild: 'rgb(181, 125, 227)',
  'Video Design': 'rgb(53, 153, 112)',
  'Website Build': 'rgb(121, 175, 253)',
  Troubleshooting: 'rgb(213, 197, 103)',
  'Marketing Collateral': 'rgb(92, 92, 92)',
  'Misc Creative': 'rgb(92, 92, 92)',
  Photography: 'rgb(255, 213, 51)',
  photography: 'rgb(255, 213, 51)',
  'Website Edits': 'rgb(201, 92, 118)',
  'Organic Social': 'rgb(255, 68, 161)',
  'Video Ads': 'rgb(255, 123, 208)',
  Video: 'rgb(255, 123, 208)',
  'Product Update': 'rgb(255, 123, 187)',

  // Review States
  'No Onboarding Sheet': 'rgb(255, 213, 51)',
  'Needs AM Review': 'rgb(255, 131, 88)',
  'Needs Revision': 'rgb(213, 197, 103)',
  'Sent for Approval': 'rgb(147, 111, 218)',
  Updates: 'rgb(147, 111, 218)',
  updates: 'rgb(147, 111, 218)',
  'Ready to Launch': 'rgb(121, 175, 253)',
  Blocked: 'rgb(133, 214, 255)',
  'Needs Copy': 'rgb(113, 214, 209)',
  'Needs CD Review': 'rgb(51, 211, 145)',
  Review: 'rgb(51, 211, 145)',
  'CD Approved': 'rgb(255, 68, 161)',
  Subtask: 'rgb(50, 158, 235)',
  subtask: 'rgb(50, 158, 235)',
  'Need Creative Attention': 'rgb(51, 158, 205)',
  'New Project Review': 'rgb(78, 115, 167)',
  'Needs PM Attention': 'rgb(255, 213, 51)',
  'With Freelancer': 'rgb(205, 146, 130)',
  Staging: 'rgb(238, 111, 141)',
  'Awaiting Kickoff': 'rgb(147, 111, 218)',

  // Display/Social
  Display: 'rgb(51, 158, 205)',
  Social: 'rgb(121, 175, 253)',

  // Search/Social Reviews
  'Search Review': 'rgb(255, 68, 161)',
  'Social Review': 'rgb(255, 123, 208)',
  'Display Review': 'rgb(147, 111, 218)',
  'Other Review': 'rgb(255, 131, 88)',
  Issue: 'rgb(238, 40, 99)',
  Internal: 'rgb(51, 158, 205)',
  Waiting: 'rgb(238, 111, 141)',
  'Need More Info': 'rgb(183, 91, 249)',

  // Teams
  AM: 'rgb(43, 118, 229)',
  PM: 'rgb(78, 115, 167)',
  DMS: 'rgb(51, 158, 205)',
  MIA: 'rgb(116, 238, 201)',
  Integration: 'rgb(116, 238, 201)',
  BDE: 'rgb(174, 92, 174)',
  Accounting: 'rgb(249, 167, 49)',
  DEV: 'rgb(23, 206, 188)',
  MGMT: 'rgb(255, 85, 0)',

  // Deal actions
  Replaced: 'rgb(239, 195, 124)',
  Replace: 'rgb(239, 195, 124)',
  replace: 'rgb(239, 195, 124)',
  Cloned: 'rgb(50, 158, 235)',
  Clone: 'rgb(50, 158, 235)',
  clone: 'rgb(50, 158, 235)',

  // Organization Types
  'Property Management Company': 'rgb(93, 79, 251)',
  'Ownership Group': 'rgb(92, 179, 253)',
  'Parent Client': 'rgb(93, 79, 251)',
  'Agency Whitelabel': 'rgb(92, 179, 253)',
  Organization: 'rgb(242, 140, 40)',
  Organizations: 'rgb(114, 229, 218)',
  organizations: 'rgb(114, 229, 218)',

  // Verticals
  'Real Estate - Student': 'rgb(255, 165, 93)',
  Student: 'rgb(255, 165, 93)',
  'Student Housing': 'rgb(255, 165, 93)',
  projects: 'rgb(245, 108, 53)',
  Projects: 'rgb(245, 108, 53)',
  'Real Estate - Senior': 'rgb(110, 156, 222)',
  Senior: 'rgb(110, 156, 222)',
  'Senior Living': 'rgb(110, 156, 222)',
  'Real Estate - MF': 'rgb(50, 187, 130)',
  MF: 'rgb(50, 187, 130)',
  Multifamily: 'rgb(50, 187, 130)',
  'Multi-Family': 'rgb(50, 187, 130)',
  'Multi Family': 'rgb(50, 187, 130)',
  'Real Estate - Homebuilding': 'rgb(132, 101, 192)',
  Homebuilding: 'rgb(132, 101, 192)',
  'Home Builder': 'rgb(132, 101, 192)',
  'Home Building': 'rgb(132, 101, 192)',
  Mortgage: 'rgb(132, 101, 192)',
  'Build to rent': 'rgb(212, 113, 91)',
  'Financial Institution': 'rgb(212, 113, 91)',
  Multiple: 'rgb(212, 113, 91)',
  Finance: 'rgb(255, 155, 147)',
  Technology: '#89CFF0',
  Medical: 'rgb(248, 131, 121)',
  Construction: 'rgb(50, 141, 181)',
  Tourism: 'rgb(212, 113, 91)',
  'Marketing Agency': 'rgb(212, 113, 91)',
  Manufacturing: 'rgb(248, 131, 121)',
  Entertainment: 'rgb(248, 131, 121)',
  Lawyer: 'rgb(248, 131, 121)',
  Education: 'rgb(248, 131, 121)',
  'City/Government': 'rgb(137, 107, 99)',
  'Restaurant (Food & Beverage)': 'rgb(224, 188, 50)',
  'Please Enter Industry': 'rgba(110, 114, 132,0.5)',
  'Not Listed': 'rgba(110, 114, 132,0.5)',
  'No Vertical Assigned': 'rgba(110, 114, 132,0.5)',
  NT: 'lightgrey',

  // Billing
  'Set Billing Status': 'rgb(178, 190, 181)',
  'Current (<60)': 'rgb(80, 200, 120)',
  'Past Due (60+)': 'rgb(249, 167, 49)',
  'Past Due (90+)': 'rgba(226, 70, 70, 0.5)',
  'Potential Bad Debt': 'rgba(226, 70, 70)',

  // Modified/Updated
  Updated: 'rgb(255, 68, 161)',
  Modified: 'rgb(255, 68, 161)',
  Modify: 'rgb(255, 68, 161)',
}

export const renderColorByString = (string: string, _hover?: boolean): string => {
  return COLOR_MAP[string] ?? 'text.primary'
}
